import React from "react"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

import HomesForHeroes from "@images/mb-about/homes-for-heroes-logo.png"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const BannerContainer = styled.div`
  max-width: 1248px;
  background-color: ${props => props.backgroundColor || "transparent"};
  margin: 0 auto;
  height: 512px;
  overflow: hidden;
  ${below.tablet`
  height: 312px;
  `}
  ${below.mobile`
    height: 256px;
  `}
  &.custom-banner {
    ${below.mobile`height: 480px;`}
  }
  @media (min-width: 601px) {
    padding: 0 48px;
  }
`

const MilitaryContainer = styled.div`
  max-width: 1248px;
  height: 100%;
  padding: 48px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${below.mobile`
    padding: 0 24px;
  `}

  h2 {
    color: white !important;
    margin-bottom: 64px;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    strong {
      font-family: "Playfair Display", serif;
    }
    ${below.tablet`
    text-align: left;
    margin-bottom: 24px !important; 
    font-size: 32px;
    line-height: 40px;
  `}
    ${below.mobile`
    margin-bottom: 48px !important; 
  `}
  }
`
const HomesForHeroesContainer = styled(MilitaryContainer)`
  ${below.mobile`
  flex-direction: column;
`}
  h2 {
    color: black !important;
    text-align: left;
    margin: 0;
    max-width: 444px;
    margin-right: 92px;
    ${below.tablet`margin-right: 64px;`}
    ${below.mobile`margin: 0 0 32px`}
  }
  img {
    height: 100%;
    max-height: 356px;
    ${below.mobile`max-height: 224px; margin: 0 auto;`}
  }
`
const MilitaryBannerContainer = styled(BannerContainer)`
  &.custom-banner {
    height: auto;
    overflow: auto;
    position: relative;
    @media (min-width: 601px) {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 268px;
      .gatsby-image-wrapper,
      img {
        min-width: 456px;
        max-width: 722px;
        width: 90.1%;
      }
    }
    @media (min-width: 951px) {
      min-height: 336px;
      .gatsby-image-wrapper,
      img {
        min-width: 634px;
        max-width: 975px;
        width: 74.2%;
      }
    }
    @media (min-width: 1440px) {
      .gatsby-image-wrapper,
      img {
        width: 975px;
      }
    }
  }
`

const MilitaryBanner = styled.div`
  align-items: center;
  display: flex;
  height: auto;
  justify-content: flex-end;
  div {
    background: #031d30;
    box-shadow: -4px -4px 24px rgba(51, 51, 51, 0.24);
    color: #fff;
    margin-bottom: -48px;
    padding: 32px;
    position: relative;
    right: 0;
    top: -48px;
    width: 90%;
  }
  h3 {
    color: #fff;
    font-family: "Playfair Display", serif;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: -0.02em;
    line-height: 44px;
    strong {
      color: #fff;
      font-family: inherit;
    }
  }
  p {
    color: var(--pacific-blue);
    font-family: "Source Sans Pro", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    margin-bottom: 0;
  }
  @media (min-width: 601px) {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    div {
      margin-bottom: 0;
      padding: 32px;
      right: 48px;
      top: 0;
      width: 376px;
      h3 {
        font-size: 36px;
        line-height: 44px;
      }
      p {
        font-size: 22px;
      }
    }
  }
  @media (min-width: 951px) {
    div {
      padding: 64px;
      width: 597px;
      h3 {
        font-size: 44px;
        line-height: 60px;
      }
    }
  }
`

const AboutBanner = props => {
  let banner = (
    <BannerContainer>
      <GatsbyImage
        image={props.image}
        style={{ height: "100%" }}
        objectFit="cover"
        objectPosition="50% 50%"
        alt=""
      />
    </BannerContainer>
  )
  if (props.title === "banner-military")
    banner = (
      <MilitaryBannerContainer className="custom-banner">
        <GatsbyImage
          image={props.image}
          style={{ height: "100%" }}
          objectFit="cover"
          objectPosition="50% 50%"
          alt=""
        />
        <MilitaryBanner>
          <div>
            <p>I'm honored</p>
            <h3>
              Proudly <strong>helping families</strong> in all branches of the
              U.S. military.
            </h3>
          </div>
        </MilitaryBanner>
      </MilitaryBannerContainer>
    )
  if (props.title === "banner-homes-for-heroes")
    banner = (
      <BannerContainer className="custom-banner" backgroundColor="#F7FAFC">
        <HomesForHeroesContainer>
          <h2 className="homes-for-heroes">
            Proudly helping our <strong>heroes</strong> buy and refinance their
            homes.
          </h2>

          <img src={HomesForHeroes} className="homes-for-heroes" alt="" />
        </HomesForHeroesContainer>
      </BannerContainer>
    )
  return banner
}

export default AboutBanner
